import { useStripe } from "@stripe/react-stripe-js";
import { PaymentIntent } from "@stripe/stripe-js";
import { useEffect, useState } from "react";

export const usePaymentIntentStatus = (
  clientSecret: string | null
): PaymentIntent.Status | "no_intent" | undefined => {
  const stripe = useStripe();
  const [paymentStatus, setPaymentStatus] = useState<
    PaymentIntent.Status | "no_intent" | undefined
  >();

  useEffect(() => {
    const getPaymentIntentStatus = async () => {
      if (!clientSecret) {
        setPaymentStatus("no_intent");
        return "no_intent";
      }
      if (!stripe) {
        return;
      }
      const { paymentIntent } =
        await stripe.retrievePaymentIntent(clientSecret);
      setPaymentStatus(paymentIntent?.status);
    };

    void getPaymentIntentStatus();
  }, [clientSecret, stripe]);

  return paymentStatus;
};
